import { Capacitor } from '@capacitor/core';

/**
 * 현재 실행 중인 플랫폼을 감지합니다.
 * @returns 'ios' | 'android' | 'web'
 */
export const getPlatform = (): 'ios' | 'android' | 'web' => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios' || platform === 'android') {
    return platform;
  }
  return 'web';
};

/**
 * iOS 앱에서 실행 중인지 확인합니다.
 */
export const isIOSApp = (): boolean => {
  return getPlatform() === 'ios';
};

/**
 * Android 앱에서 실행 중인지 확인합니다.
 */
export const isAndroidApp = (): boolean => {
  return getPlatform() === 'android';
};

/**
 * 네이티브 앱(iOS 또는 Android)에서 실행 중인지 확인합니다.
 */
export const isNativeApp = (): boolean => {
  const platform = getPlatform();
  return platform === 'ios' || platform === 'android';
};

/**
 * 웹 브라우저에서 실행 중인지 확인합니다.
 */
export const isWeb = (): boolean => {
  return getPlatform() === 'web';
};

